'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * IDs and keys
 */

var PRODIGY_UI_THEME = exports.PRODIGY_UI_THEME = '__PRODIGY_UI_THEME__';
var TASK_ID = exports.TASK_ID = '_task_hash';
var NO_ENTITY = exports.NO_ENTITY = 'O';
var NO_LABEL = exports.NO_LABEL = 'NO_LABEL';
var BUTTONS = exports.BUTTONS = ['accept', 'reject', 'ignore', 'undo'];
var IMAGE_MANUAL_MODES = exports.IMAGE_MANUAL_MODES = ['rect', 'polygon', 'freehand'];
var BOX_COLORS = exports.BOX_COLORS = ['yellow', 'cyan', 'magenta', 'springgreen', 'tomato', 'deepskyblue', 'orange', 'hotpink', 'aquamarine', 'gold', 'peachpuff', 'greenyellow', 'tan', 'gainsboro'];
var RELATION_COLORS = exports.RELATION_COLORS = ['#c5bdf4', '#ffd882', '#d9fbad', '#c2f2f6', '#ffdaf9', '#b5c6c9', '#96e8ce', '#ffd1b2'];
var AUDIO_COLORS = exports.AUDIO_COLORS = ['gold', 'cyan', 'magenta', 'lime', 'darkorchid', 'deepskyblue', 'coral', 'mediumaquamarine'];
/**
 * Icons
 */

var ICONS = exports.ICONS = {
  reject: {
    viewBox: '0 0 24 24',
    paths: [{
      d: 'M18.984 6.422l-5.578 5.578 5.578 5.578-1.406 1.406-5.578-5.578-5.578 5.578-1.406-1.406 5.578-5.578-5.578-5.578 1.406-1.406 5.578 5.578 5.578-5.578z'
    }]
  },
  accept: {
    viewBox: '0 0 24 24',
    paths: [{
      d: 'M9 16.172l10.594-10.594 1.406 1.406-12 12-5.578-5.578 1.406-1.406z'
    }]
  },
  ignore: {
    viewBox: '0 0 24 24',
    paths: [{
      d: 'M12 20.016c4.406 0 8.016-3.609 8.016-8.016 0-1.828-0.609-3.563-1.688-4.922l-11.25 11.25c1.359 1.078 3.094 1.688 4.922 1.688zM3.984 12c0 1.828 0.609 3.563 1.688 4.922l11.25-11.25c-1.359-1.078-3.094-1.688-4.922-1.688-4.406 0-8.016 3.609-8.016 8.016zM12 2.016c5.531 0 9.984 4.453 9.984 9.984s-4.453 9.984-9.984 9.984-9.984-4.453-9.984-9.984 4.453-9.984 9.984-9.984z'
    }]
  },
  undo: {
    viewBox: '0 0 24 24',
    paths: [{
      d: 'M11.016 9l1.406 1.406-3.609 3.609h9.188v-10.031h2.016v12h-11.203l3.609 3.609-1.406 1.406-6-6z'
    }]
  },
  close: {
    viewBox: '0 0 24 24',
    paths: [{
      d: 'M18.984 6.422l-5.578 5.578 5.578 5.578-1.406 1.406-5.578-5.578-5.578 5.578-1.406-1.406 5.578-5.578-5.578-5.578 1.406-1.406 5.578 5.578 5.578-5.578z'
    }]
  },
  menu: {
    viewBox: '0 0 24 24',
    paths: [{
      d: 'M3 5h18q0.414 0 0.707 0.293t0.293 0.707-0.293 0.707-0.707 0.293h-18q-0.414 0-0.707-0.293t-0.293-0.707 0.293-0.707 0.707-0.293zM3 17h18q0.414 0 0.707 0.293t0.293 0.707-0.293 0.707-0.707 0.293h-18q-0.414 0-0.707-0.293t-0.293-0.707 0.293-0.707 0.707-0.293zM3 11h18q0.414 0 0.707 0.293t0.293 0.707-0.293 0.707-0.707 0.293h-18q-0.414 0-0.707-0.293t-0.293-0.707 0.293-0.707 0.707-0.293z'
    }]
  },
  save: {
    viewBox: '0 0 20 20',
    paths: [{
      d: 'M15.173 2h-11.173c-1.101 0-2 0.9-2 2v12c0 1.1 0.899 2 2 2h12c1.101 0 2-0.9 2-2v-10.873l-2.827-3.127zM14 8c0 0.549-0.45 1-1 1h-6c-0.55 0-1-0.451-1-1v-5h8v5zM13 4h-2v4h2v-4z'
    }]
  },
  infinity: {
    viewBox: '0 0 32 32',
    paths: [{
      d: 'M24.5 23.5c-2.003 0-3.887-0.78-5.303-2.197l-3.197-3.196-3.196 3.196c-1.417 1.417-3.3 2.197-5.303 2.197s-3.887-0.78-5.304-2.197c-1.417-1.417-2.197-3.3-2.197-5.303s0.78-3.887 2.197-5.304c1.417-1.417 3.3-2.197 5.304-2.197s3.887 0.78 5.303 2.197l3.196 3.196 3.196-3.196c1.417-1.417 3.3-2.197 5.303-2.197s3.887 0.78 5.303 2.197c1.417 1.417 2.197 3.3 2.197 5.304s-0.78 3.887-2.197 5.303c-1.416 1.417-3.3 2.197-5.303 2.197zM21.304 19.197c0.854 0.853 1.989 1.324 3.196 1.323s2.342-0.47 3.196-1.324c0.854-0.854 1.324-1.989 1.324-3.196s-0.47-2.342-1.324-3.196c-0.854-0.854-1.989-1.324-3.196-1.324s-2.342 0.47-3.196 1.324l-3.196 3.196 3.196 3.197zM7.5 11.48c-1.207 0-2.342 0.47-3.196 1.324s-1.324 1.989-1.324 3.196c0 1.207 0.47 2.342 1.324 3.196s1.989 1.324 3.196 1.324c1.207 0 2.342-0.47 3.196-1.324l3.196-3.196-3.196-3.196c-0.854-0.854-1.989-1.324-3.196-1.324v0z'
    }]
  },
  plus: {
    viewBox: '0 0 24 24',
    paths: [{
      d: 'M18.984 12.984h-6v6h-1.969v-6h-6v-1.969h6v-6h1.969v6h6v1.969z'
    }]
  },
  flag: {
    viewBox: '0 0 24 24',
    paths: [{
      d: 'M14.391 6h5.625v9.984h-7.031l-0.375-1.969h-5.625v6.984h-1.969v-17.016h9z'
    }]
  },
  rect: {
    viewBox: '0 0 24 24',
    paths: [{
      d: 'M3.3 5a2.3 2.3 0 100 4.7 2.3 2.3 0 000-4.7zM20.6 9.6a2.3 2.3 0 100-4.6 2.3 2.3 0 000 4.6zM3.3 16.5a2.3 2.3 0 100 4.6 2.3 2.3 0 000-4.6zM20.6 16.5a2.3 2.3 0 100 4.6 2.3 2.3 0 000-4.6zM4 15.3v-4.4a.7.7 0 00-1.4 0v4.4a.7.7 0 001.4 0zM17.1 6.6H6.8a.7.7 0 100 1.5h10.3a.7.7 0 100-1.5zM17.1 18H6.8a.7.7 0 100 1.5h10.3a.7.7 0 100-1.5zM20 10.9v4.4a.7.7 0 101.4 0v-4.4a.7.7 0 00-1.5 0z'
    }]
  },
  polygon: {
    viewBox: '0 0 24 24',
    paths: [{
      d: 'M14 4.8c-.2.3 0 .7.2 1l3.5 2.5a.7.7 0 001-.2c.2-.3.2-.7-.2-1l-3.4-2.5a.7.7 0 00-1 .2zM12 5.5A2.2 2.2 0 1012 1a2.2 2.2 0 000 4.5zM20.8 7.4a2.2 2.2 0 100 4.5 2.2 2.2 0 000-4.5zM17.4 17.7a2.2 2.2 0 100 4.5 2.2 2.2 0 000-4.5zM6.6 17.7a2.2 2.2 0 100 4.5 2.2 2.2 0 000-4.5zM5.5 9.6a2.2 2.2 0 10-4.5 0 2.2 2.2 0 004.5 0zM5.9 8.4l.4-.1 3.5-2.5a.7.7 0 10-.9-1.2L5.5 7.2a.7.7 0 00.4 1.2zM5.6 17.6h.2c.4-.2.6-.6.4-1l-1.3-4a.7.7 0 10-1.3.4l1.3 4c.1.4.4.6.7.6zM20 12a.7.7 0 00-1 .5l-1.2 4.1a.7.7 0 101.3.5l1.3-4.1c.2-.4 0-.8-.4-1zM14.2 19.2H9.8a.7.7 0 100 1.5h4.4a.7.7 0 100-1.5z'
    }]
  },
  freehand: {
    viewBox: '0 0 24 24',
    paths: [{
      d: 'M6.9 20.8a13 13 0 01-3.3-3.6c-.3-.7-.4-1.3-.4-1.8 0-.7.4-1.2 1-1.7a2 2 0 011.4-.3c.4 0 .9.1 1.5.4a22.4 22.4 0 013 1.9l2.4 1.2c-.4-1-.7-1.5-2.4-3.5l-.6-.8a17.6 17.6 0 01-2.3-3.5c-.3-.8-.4-1.5-.4-2 0-.8.4-1.4 1-1.8.6-.4 1.2-.6 1.9-.6.6 0 1.2.2 2 .6a15.8 15.8 0 013.5 3 26 26 0 003 2.7c0-.4-.2-.9-.5-1.5-.8-1.5-2.3-3.5-4.5-6-.3-.5-.2-.9.2-1.3s.8-.4 1.2-.1c1.7 1.8 4.6 4.8 5.5 6.5.5 1 .8 1.9.8 2.6 0 1-.3 1.6-1 2.2-.5.4-1.1.5-1.8.4-.5-.1-1.2-.4-1.8-1a25.3 25.3 0 01-3.5-3.1c-1.1-1.1-2-1.8-2.7-2.2l-.5-.2c-.2.2-.1.4 0 .6a14.6 14.6 0 002.6 3.8c1.7 2.2 2 2.6 2.5 3.5.5.8.8 1.4.8 2a2 2 0 01-.8 1.8c-.7.6-1.5.8-2.6.5a12.1 12.1 0 01-4-2 35.3 35.3 0 00-2-1.2c.3.8 1 1.8 2.2 3.1.3.6.3 1-.1 1.4-.4.4-.8.4-1.3 0z'
    }]
  },
  "delete": {
    viewBox: '0 0 24 24',
    paths: [{
      d: 'M15.516 3.984h3.469v2.016h-13.969v-2.016h3.469l1.031-0.984h4.969zM8.438 11.859l2.156 2.156-2.109 2.109 1.406 1.406 2.109-2.109 2.109 2.109 1.406-1.406-2.109-2.109 2.109-2.156-1.406-1.406-2.109 2.156-2.109-2.156zM6 18.984v-12h12v12c0 1.078-0.938 2.016-2.016 2.016h-7.969c-1.078 0-2.016-0.938-2.016-2.016z'
    }]
  },
  reset: {
    viewBox: '0 0 24 24',
    paths: [{
      d: 'M6 12h3l-3.984 3.984-4.031-3.984h3c0-4.406 3.609-8.016 8.016-8.016 1.547 0 3.047 0.469 4.266 1.266l-1.453 1.453c-0.844-0.469-1.781-0.703-2.813-0.703-3.328 0-6 2.672-6 6zM18.984 8.016l4.031 3.984h-3c0 4.406-3.609 8.016-8.016 8.016-1.547 0-3.047-0.469-4.266-1.266l1.453-1.453c0.844 0.469 1.781 0.703 2.813 0.703 3.328 0 6-2.672 6-6h-3z'
    }]
  },
  help: {
    viewBox: '0 0 20 20',
    paths: [{
      d: 'M10 0.4c-5.302 0-9.6 4.298-9.6 9.6s4.298 9.6 9.6 9.6c5.301 0 9.6-4.298 9.6-9.601 0-5.301-4.299-9.599-9.6-9.599zM9.849 15.599h-0.051c-0.782-0.023-1.334-0.6-1.311-1.371 0.022-0.758 0.587-1.309 1.343-1.309l0.046 0.002c0.804 0.023 1.35 0.594 1.327 1.387-0.023 0.76-0.578 1.291-1.354 1.291zM13.14 9.068c-0.184 0.26-0.588 0.586-1.098 0.983l-0.562 0.387c-0.308 0.24-0.494 0.467-0.563 0.688-0.056 0.174-0.082 0.221-0.087 0.576v0.090h-2.145l0.006-0.182c0.027-0.744 0.045-1.184 0.354-1.547 0.485-0.568 1.555-1.258 1.6-1.287 0.154-0.115 0.283-0.246 0.379-0.387 0.225-0.311 0.324-0.555 0.324-0.793 0-0.334-0.098-0.643-0.293-0.916-0.188-0.266-0.545-0.398-1.061-0.398-0.512 0-0.863 0.162-1.072 0.496-0.216 0.341-0.325 0.7-0.325 1.067v0.092h-2.211l0.004-0.096c0.057-1.353 0.541-2.328 1.435-2.897 0.563-0.361 1.264-0.544 2.081-0.544 1.068 0 1.972 0.26 2.682 0.772 0.721 0.519 1.086 1.297 1.086 2.311-0.001 0.567-0.18 1.1-0.534 1.585z'
    }]
  },
  play: {
    viewBox: '0 0 24 24',
    paths: [{
      d: 'M8 5v14l11-7z'
    }]
  },
  pause: {
    viewBox: '0 0 24 24',
    paths: [{
      d: 'M6 19h4V5H6v14zm8-14v14h4V5h-4z'
    }]
  },
  zoom: {
    viewBox: '0 0 24 24',
    paths: [{
      d: 'M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z'
    }, {
      d: 'M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z'
    }]
  },
  loop: {
    viewBox: '0 0 24 24',
    paths: [{
      d: 'M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4z'
    }]
  },
  loopone: {
    viewBox: '0 0 24 24',
    paths: [{
      d: 'M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4zm-4-2V9h-1l-2 1v1h1.5v4H13z'
    }]
  },
  spans: {
    viewBox: '0 0 24 24',
    paths: [{
      d: 'M21.4 7.1h-2.6v3.6a1.8 1.8 0 010 2.7v3.7h2.6c.3 0 .6-.3.6-.6V7.7c0-.3-.3-.6-.6-.6zM13.3 13.4a1.8 1.8 0 010-2.7V7.1H2.6c-.3 0-.6.3-.6.6v8.8c0 .3.3.6.6.6h10.7v-3.7zM16.4 18.1v-5.4c.4 0 .7-.3.7-.6s-.3-.6-.6-.6V6.1l1-1.1c.3-.2.3-.6 0-.8a.6.6 0 00-.8 0l-.9.8-.8-.8a.6.6 0 00-.8 0c-.3.2-.3.6 0 .8l1 1v5.5c-.3 0-.6.3-.6.6s.3.6.6.6V18l-1 1.1c-.3.2-.3.6 0 .8.2.3.6.3.8 0l.8-.8.9.8c.2.3.6.3.8 0 .3-.2.3-.6 0-.8l-1-1z'
    }]
  },
  rels: {
    viewBox: '0 0 24 24',
    paths: [{
      d: 'M19 9.9l-2.7-1.6a.5.5 0 01.5-.9L19 8.7l1.3-2.4a.5.5 0 01.9.5l-1.5 2.8c-.1.3-.5.4-.7.3z M3.2 9.4a.5.5 0 01-.3-.5A8.5 8.5 0 0115.3 3c2.3 1.2 3.9 3.4 4.4 6a.5.5 0 01-1.1.2A7.5 7.5 0 004 9.2a.5.5 0 01-.8.2z M14 12h8c.6 0 1 .5 1 1v2c0 .6-.4 1-1 1h-.4c-.9 0-2-2-3.1-2-2 0-1.1 2-1.5 2h-3a1 1 0 01-1-1v-2c0-.5.4-1 1-1z M14 11h8c.6 0 1 .4 1 1v4c0 .6-.4 1-1 1h-.4c-.9 0-2-2-3.1-2-2 0-1.1 2-1.5 2h-3a1 1 0 01-1-1v-4c0-.6.4-1 1-1z M18.3 22a.4.4 0 00.4-.1l1.6-1.9h2.3c.2 0 .3-.1.4-.3 0-.1 0-.3-.2-.4L18.7 16a.4.4 0 00-.5 0c-.1 0-.2.1-.2.3v5.2c0 .2.1.3.3.4z M2 11h8c.6 0 1 .4 1 1v4c0 .6-.4 1-1 1H2a1 1 0 01-1-1v-4c0-.6.4-1 1-1z'
    }]
  }
};